import React from "react";

import DesktopContainerDrawer from "containers/DesktopContainerDrawer";
import MobileContainerDrawer from "containers/MobileContainerDrawer";

import MenuScreenBodyDesktop from "./MenuScreen/MenuScreenBodyDesktop";
import MenuScreenBodyMobile from "./MenuScreen/MenuScreenBodyMobile";

const MenuScreenBody = () => (
	<>
		<DesktopContainerDrawer>
			<MenuScreenBodyDesktop />
		</DesktopContainerDrawer>
		<MobileContainerDrawer>
			<MenuScreenBodyMobile />
		</MobileContainerDrawer>
	</>
);

export default MenuScreenBody;
